"use client"
import React from "react"
import dynamic from 'next/dynamic';
const Footer = dynamic(() => import('@/Component/Footer'), { ssr: false });
const Header = dynamic(() => import('@/Component/Header'), { ssr: false });

import styles from "./ContactUsPage.module.css";
import TitleText from "../TitleText";
import email_icon from "@/assets/Icon/Email_Icon.png"
import location_icon from "@/assets/Icon/Location_Icon.png"
import { useTranslation } from "react-i18next";
import Image from "next/image";
const ContactUsPage = () => {
    const { t } = useTranslation();
    return (
        <div className={styles.contactus}>
            <Header></Header>
            <TitleText titleTextInfo={{ textKey: "Header.Category.ContactUs" }}>

            </TitleText>

            <div className={styles.contactus__container}>

                <div className={styles.contactus__content}>
                    <span className={styles.contactus__title__text}>
                        {t("ContactUs.Title")}
                    </span>

                    <div className={styles.contactus__text__content}>
                        <div className={styles.contactus__title__text__content}>
                            <div className={styles.contactus__title__text__image__container}>
                                <Image src={email_icon} className={styles.contactus__title__text__image} alt="email"/>
                            </div>
                            <span className={styles.contactus__title__text}>
                                {t("ContactUs.Email.Title")}
                            </span>
                        </div>

                        <a href='mailto:contact@bepex.xyz' className={styles.contactus__description__text}>
                            {t("ContactUs.Emal.Description")}
                        </a>
                    </div>


                    <div className={styles.contactus__text__content}>
                        <div className={styles.contactus__title__text__content}>
                            <div className={styles.contactus__title__text__image__container}>

                                <Image src={location_icon} className={styles.contactus__title__text__image} alt="location_icon" />
                            </div>
                            <span className={styles.contactus__title__text}>
                                {t("ContactUs.Location.Title")}
                            </span>
                        </div>
                        <iframe src="https://www.google.com/maps?q=서울특별시%20마포구%20매봉산로%2031%20에스플렉스센터&output=embed"
                            className={styles.contactus__map} loading="lazy" ></iframe>
                        <span className={styles.contactus__description__text}>
                            {t("ContactUs.Location.Description")}
                        </span>
                    </div>
                </div>
            </div>
            <Footer></Footer>
        </div>
    );
}


export default ContactUsPage;
